import { UserDroitsProvider } from 'features/utilisateurs/contexts/UtilisateurDroitsProvider';
import { UserInfosProvider } from 'features/utilisateurs/contexts/UtilisateurInfosProvider';
import { UserPerimetreProvider } from 'features/utilisateurs/contexts/UtilisateurPerimetreProvider';
import { UtilisateurFormProvider } from 'features/utilisateurs/contexts/UtilisateurFormProvider';
import React from 'react';
import UserPageAdd from 'features/utilisateurs/components/UsersPageAdd';
import { TypeMode } from 'core/models';
import SmallHeader from 'features/utilisateurs/components/header';
import SmallFooter from 'features/utilisateurs/components/Footer';
import { SGSHelpButton } from 'components';

type Props = {
    mode?: TypeMode;
};

const UsersPageAdd: React.FC<Props> = ({ mode = 'create' }) => {
    return (
        <>
            <SGSHelpButton />
            <UtilisateurFormProvider>
                <UserInfosProvider>
                    <UserPerimetreProvider>
                        <UserDroitsProvider>
                            {mode === 'newUser' && <SmallHeader className={'mb-5'} />}
                            <UserPageAdd mode={mode} />
                            {mode === 'newUser' && <SmallFooter className={'mt-5'} />}
                        </UserDroitsProvider>
                    </UserPerimetreProvider>
                </UserInfosProvider>
            </UtilisateurFormProvider>
        </>
    );
};

export default UsersPageAdd;
